const zzzfunPlatforms = [
  {
    icon: 'ri-android-fill',
    name: 'Android',
    desc: '安卓手机与平板',
    points: ['支持 4K 画质播放', '后台缓存不中断', '适配折叠屏与平板'],
  },
  {
    icon: 'ri-apple-fill',
    name: 'iOS',
    desc: 'iPhone 与 iPad',
    points: ['全面适配横竖屏', 'AirPlay 一键投屏', '系统级深色模式跟随'],
  },
  {
    icon: 'ri-smartphone-line',
    name: 'HarmonyOS',
    desc: '鸿蒙设备',
    points: ['鸿蒙原生流畅体验', '多设备接续观看', '卡片式更新提醒'],
  },
  {
    icon: 'ri-windows-fill',
    name: 'Windows',
    desc: 'Windows 电脑版',
    points: ['大屏高清播放', '快捷键操控', '支持画中画小窗'],
  },
];

export default function ZzzfunPlatforms() {
  return (
    <section id="zzzfun-platforms" className="scroll-mt-24 bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-primary-600">Platforms</span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">全平台支持</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            ZzzFun覆盖主流设备，一份账号全端通看，进度与收藏实时同步。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {zzzfunPlatforms.map((platform) => (
            <div
              key={platform.name}
              className="flex flex-col rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-6"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className={`${platform.icon} text-2xl`} />
              </span>
              <h3 className="mt-4 text-lg font-bold text-foreground-950">{platform.name}</h3>
              <p className="mt-1 text-xs text-foreground-600">{platform.desc}</p>
              <ul className="mt-4 flex flex-col gap-2">
                {platform.points.map((point) => (
                  <li key={point} className="flex items-start gap-2 text-sm text-foreground-700">
                    <i className="ri-check-line mt-0.5 text-base text-accent-600" />
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center text-sm text-foreground-600">
          所有平台均通过官方渠道发布，可放心获取。
        </p>
      </div>
    </section>
  );
}